<template>
    <div id="stamp-exchange">
        <div id="header">
            <img class="back" src="../../assets/common_back.png" alt=""
                 @click="back">
            <span class="title">印花兑换礼品</span>
        </div>

        <div class="tip-text">温馨提示：如需兑换益力多或益力多低糖，请联系益力多姐姐</div>
        <div class="exchange-box">
            <div v-if="isShow" class="exchange-no">暂无可兑换礼品</div>
            <div v-else id="body" v-for="(item, index) in actionData" :key="index">
                <div class="body-title">
                    <div class="action">
                        <div class="consume-stamp">所需印花:{{item.stampQuantity}}分</div>
                        <div class="action-title">{{item.productName}}</div>
                    </div>
                    <div v-if="item.joined" class="exchange" style="background: #cccccc">
                        已兑换
                    </div>
                    <div v-else  class="exchange" @click="stampExchange(item.activityId, item.stampQuantity)">
                        兑换抽奖资格
                    </div>

                </div>

                <div style="clear:both;"></div>

                <div class="action-detail">

                    <div v-if="item.imgUrl" class="action-img">
                        <img class="img"  :src="item.imgUrl" alt="">
                    </div>

                    <div class="action-explain" v-html="item.content">

                    </div>
                </div>

                <div style="clear:both;"></div>
            </div>
        </div>

        <div class="back-btn" @click="back">返回</div>
        <img class="exchange-icon" src="../../assets/member_print_description_bottom_icon.png" />
    </div>
</template>

<script>

    import {getActivityList} from "../../api/Stamp";
    import {BASE_URL} from "@/config/app";

    export default {
        name: "StampExchange",

        data() {
              return {
                  actionData:[],

                  page: 1,
                  limit: -1,

                  isShow: false,
              }
        },

        mounted() {
            this.getActivityList();
        },

        methods: {

            stampExchange(activityId, stampQuantity) {
                this.$router.push({path: '/stampExchangeReport', query:{activityId, stampQuantity}})
            },

            getActivityList() {
                getActivityList().then(response => {
                    if (response.code === this.$API_CODE.OK) {
                        this.actionData = [];

                        if (response.data && response.data.length > 0) {
                            this.isShow = false;
                        } else {
                            this.isShow = true;
                        }

                        response.data.forEach((item) => {
                            this.actionData.push({
                                activityId: item.id,
                                productName: item.productname,
                                content: item.content,
                                imgUrl: BASE_URL + item.imgurl,
                                joined: item.joined,
                                stampQuantity: item.stampQuantity,
                            })
                        })
                    }
                })
            },

            back() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped lang="scss">
    #stamp-exchange {
        //header区域
        #header {
            height: 45px;
            line-height: 45px;
            background-color: #ed3f14;

            .back {
                margin-top: 13px;
                line-height: 35px;
                margin-left: 10px;
                float: left;
            }
            .title {
                color: white;
            }
        }

        .tip-text {
            margin: 5px;
            font-size: 0.8rem;
        }

        .exchange-box {
            background: #FFFFFF;
            margin: 10px 20px 40px 20px;
            border: 2px solid #ed3f14;
            border-radius: 10px;

            .exchange-no {
                padding: 20px;
            }
            #body {
                border-bottom: 1px solid #ed3f14;
                margin-right: 15px;
                margin-left: 15px;
                padding-bottom: 10px;
                margin-bottom: 15px;

                .body-title {
                    height: 50px;
                    margin-top: 20px;
                    color: #000000;
                    .action {
                        float: left;
                        text-align: left;
                        line-height: 25px;

                        .consume-stamp {
                            color: #ed3f14;
                            font-size: 0.9rem;
                            font-weight: bold;
                        }
                    }

                    .exchange {
                        line-height: 35px;
                        width: 100px;
                        height: 35px;
                        float: right;
                        border-radius: 5px;
                        background: #ed3f14;
                        color: #FFFFFF;
                        font-weight: bold;
                    }
                }

                .action-detail {
                    margin-top: 5px;
                    .action-img {
                        float: left;
                        width: 100px;
                        height: 100px;
                        margin-right: 20px;

                        .img {
                            width: 100px;
                            height: 100px;
                        }
                    }

                    .action-explain {
                        text-align: left;
                        margin-right: 20px;
                        //white-space: pre-line;
                    }
                }
            }
        }

        .exchange-icon {
            width: 100%;
            position: fixed;
            bottom: 0;
            left: 0;
        }

        .back-btn {
            margin: auto;
            width: 80%;
            font-size: 1rem;
            font-weight: bold;
            color: #ea2d53;
            border: 1px solid #ea2d53;
            border-radius: 5px;
            padding: 10px;
            margin-bottom: 40px;
        }


    }
</style>